import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";
import "react-tabs/style/react-tabs.css";
import ClientInfoPanelContainer from "./ClientInfoPanelContainer";
import CardSettingsPanelContainer from './CardSettingsPanel.container';

const StyledTabs = styled(Tabs)`
  background-color: #1e2832;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  // border: 1px solid #1e2832;
  // border-bottom: none;
  height: 100%;
`;

const StyledTabList = styled(TabList)`
  margin: 0px;
  /* margin-bottom: 0px; */
  & > li {
    border: 5px;
    outline: 0;
    -webkit-box-shadow: inset 2px -12px 4px -9px rgba(31, 30, 29, 1);
    -moz-box-shadow: inset 2px -12px 4px -9px rgba(31, 30, 29, 1);
    box-shadow: inset 2px -12px 4px -9px rgba(31, 30, 29, 1);
    margin-left: 2px;
  }
  & > li[aria-selected="true"] {
    color: white;
    box-shadow: none;
    border: 5px;
  }
  & > li[aria-selected="false"] {
    border-radius: 5px;
  }
`;

const StyledTabPanel = styled(TabPanel)`
  padding-top: 5px;
  // padding-left: 1px;
  /* padding-left: 3px; */
  min-width: 100%;
`;

export default function Sidebar() {

  return (
    <StyledTabs>
      <StyledTabList>
        <Tab
          style={{
            backgroundColor: "#2c3742",
            boxShadow: "box-shadow: inset 2px -12px 4px -6px white"
          }}
        >
          Client Info
        </Tab>
        <Tab style={{ backgroundColor: "#2c3742" }}>Card Settings</Tab>
      </StyledTabList>
      <StyledTabPanel style={{ backgroundColor: "#2c3742" }}>
        <ClientInfoPanelContainer/>
      </StyledTabPanel>
      <StyledTabPanel style={{ backgroundColor: "#2c3742" }}>
          <CardSettingsPanelContainer />
      </StyledTabPanel>
    </StyledTabs>
  );
  
}
